// extracted by mini-css-extract-plugin
export default {"container":"Marquee_container__uanzX","marquee":"Marquee_marquee__4nbAi","arabicMarquee":"Marquee_arabicMarquee__qhVc7"};